import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `
    <img 
      [src]="'/' + filename" 
      [style.width]="width" 
      [style.height]="height" 
      alt="Logotipo"
      style="display: block; object-fit: contain;"
    />
  `
})
export class LogoComponent {
  @Input() filename: string = 'logo-portal-fornecedor.svg'; // Nome do arquivo dentro da pasta public
  @Input() width: string = '225px';// Largura padrão
  @Input() height: string = 'auto';// Altura se adapta proporcionalmente
}